import { createFileRoute } from "@tanstack/react-router";
import { Table } from "@heroui/react";

import { useDirections } from "@/features/directions/use-directions.ts";
import { DirectionEntity } from "@/features/directions/type.ts";
import { CreateDirectionModal } from "@/features/directions/ui/create-direction-modal.tsx";
import { ToggleDirectionStatus } from "@/features/directions/ui/toggle-direction-status.tsx";
import { EditDirectionModal } from "@/features/directions/ui/edit-direction-modal.tsx";
import { DeleteDirectionModal } from "@/features/directions/ui/delete-direction-modal.tsx";

export const Route = createFileRoute("/dashboard/directions")({
  component: RouteComponent,
});

function RouteComponent() {
  const { data } = useDirections();

  return (
    <div className="flex flex-col pt-4">
      <div className="flex flex-row gap-2 justify-between">
        <p className="font-bold text-xl">Направления</p>

        <CreateDirectionModal />
      </div>

      <Table.Root className="mt-8">
        <Table.Content aria-label="Список направлений">
          <Table.Header>
            <Table.Column>ID</Table.Column>
            <Table.Column>Откуда</Table.Column>
            <Table.Column>Куда</Table.Column>
            <Table.Column>Видимый</Table.Column>
            <Table.Column> </Table.Column>
          </Table.Header>
          <Table.Body items={data.data}>
            {(direction: DirectionEntity) => (
              <Table.Row id={String(direction.id)}>
                <Table.Cell>{direction.id}</Table.Cell>
                <Table.Cell>{direction.fromCity.name}</Table.Cell>
                <Table.Cell>{direction.toCity.name}</Table.Cell>
                <Table.Cell>
                  <ToggleDirectionStatus
                    defaultSelected={direction.isActive}
                    fromCityId={direction.fromCity.id}
                    id={direction.id}
                    toCityId={direction.toCity.id}
                  />
                </Table.Cell>
                <Table.Cell>
                  <div className="flex flex-row gap-2 justify-end">
                    <EditDirectionModal direction={direction} />

                    <DeleteDirectionModal directionId={direction.id} />
                  </div>
                </Table.Cell>
              </Table.Row>
            )}
          </Table.Body>
        </Table.Content>
      </Table.Root>
    </div>
  );
}
